module.exports = __webpack_public_path__ + "img/winter-jacket.7c25b1fb.png";